export default __webpack_public_path__ + "static/media/2-Sevan-Hvilken betydning hadde identiteten din for flukten.c1af9135.mp4";